import Label from '../../pages/Labels'
import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'

export const LabelsRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route path="/labels" exact component={Label} />
  </CustomSwitch>
)
